<template>
    <div class="grid grid-cols-5 gap-3">
        <span class="border px-2 py-1 rounded bg-white">BP: {{ budgetProgetto }}</span>
        <span class="border px-2 py-1 rounded bg-white">TC: {{ totaleCosti }}</span>
        <span class="border px-2 py-1 rounded bg-white">PM: {{ primoMarigne }}</span>
        <span class="border px-2 py-1 rounded bg-white">PM: {{ primoMarignePerc }}</span>
        <span class="border px-2 py-1 rounded bg-white">F: {{ fee }}</span>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import CardDivisorioGrigio from "@/components/CardDivisorioGrigio.vue";

@Options({
    name:'SezioneHead',
    components: {
        CardDivisorioGrigio
    },
    props: {
        totaleCosti: String,
        budgetProgetto: String,
        primoMarignePerc: String,
        fee: String,
        primoMarigne: String,
    },

})
export default class SezioneHead extends Vue {

}

</script>

<style lang="scss">

</style>
